import {useContext, useEffect, useState} from "react";
import {Input, Pagination} from 'antd';
import {ApiConsumer} from "../components/api/ApiConsumer";
import {API_URLS} from "../components/config";
import Loader from "../components/loader";
import {Row} from "../components/application/row";
import Empty from "../components/empty";
import {TitleContext} from "../components/contexts/Title";
import {useParams} from "react-router";

const ApplicationsByJob = () => {
    const [applications, setApplications] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [total, setTotal] = useState(0);
    const [filters, setFilters] = useState({
        size: 20,
        page: 1,
        search: '',
        qualification: '',
        min_years_experience: ''
    })

    let {setTitle} = useContext(TitleContext);
    let {id} = useParams()

    useEffect(() => {
        setTitle('Job Applications')
    }, [])

    useEffect(() => {
        setLoaded(false)
        ApiConsumer(API_URLS.APPLICATIONS.JOB(id), {
            params: {
                ...filters,
                size: pageSize,
                page: page
            }
        })
            .then(res => {
                setApplications(res.data.data)
                setTotal(res.data?.count ?? 0)
                setPage(res.data?.current_page ?? 1)
                setPageSize(res.data?.size ?? 20)
            })
            .catch(err => console.error(err))
            .finally(() => setLoaded(true))
    }, [page])

    return <>
        <div id="messages" className="card">
            <div className="card-body">
                <div className="row mb-3">
                    <div className="col-md-4 mb-2">
                        <Input placeholder="Search applicants"
                               value={filters.search}
                               onChange={event => setFilters(prevState => ({
                                   ...prevState,
                                   search: event.target.value
                               }))}/>
                    </div>
                    <div className="col-md-4 mb-2">
                        <Input placeholder="Qualification, e.g. B.Com"
                               value={filters.qualification}
                               onChange={event => setFilters(prevState => ({
                                   ...prevState,
                                   qualification: event.target.value
                               }))}/>
                    </div>
                    <div className="col-md-3 mb-2">
                        <Input placeholder="Min years experience"
                               value={filters.min_years_experience}
                               onChange={event => setFilters(prevState => ({
                                   ...prevState,
                                   min_years_experience: event.target.value
                               }))}/>
                    </div>
                    <div className="col-md-1 mb-2">
                        <button className="btn btn-sm rounded-round bg-pps-blue btn-lg legitRipple w-100"
                                onClick={() => {
                                    setPage(1)
                                    setLoaded(false)
                                    ApiConsumer(API_URLS.APPLICATIONS.JOB(id), {
                                        params: {
                                            ...filters,
                                            size: pageSize,
                                            page: 1
                                        }
                                    })
                                        .then(res => {
                                            setApplications(res.data.data)
                                            setTotal(res.data?.count ?? 0)
                                            setPage(res.data?.current_page ?? 1)
                                            setPageSize(res.data?.size ?? 20)
                                        })
                                        .catch(err => console.error(err))
                                        .finally(() => setLoaded(true))
                                }}>
                            Go
                        </button>
                    </div>
                </div>
                {
                    loaded ?
                        applications.length === 0 ?
                            <Empty description={'No Applications'}/> :
                            applications.map(application => {
                                return <Row application={application}/>
                            }) : <Loader/>
                }
            </div>
        </div>


        <div className="d-flex justify-content-center pt-3 mb-4">
            <Pagination className="pagination shadow-1 text-center"
                        total={total}
                        current={page}
                        pageSize={20}
                        onChange={selected => {
                            setPage(selected)
                        }}
            />
        </div>
    </>
}
export default ApplicationsByJob;
